import {
  BULK_UPDATE_SCRIPT,
  CHANGE_SCRIPT_DATA, DELETE_SCRIPT_DATA, DELETE_SCRIPT_NOTE, DELIVERY_METHOD,
  GET_PATIENT_SCRIPTS, GET_SCRIPT_ATTACHMENTS,
  GET_SCRIPT_PAYMENTS,
  GET_SCRIPT_STATUS,
  GET_SCRIPTS,
  GET_SCRIPTS_NOTES, POSTAL_SERVICES_DATA,
  SCRIPT_NOTE_OR_ATTACHMENT_IDS, SET_SCROLLING_TO_NOTE, US_POSTAL_RESPONSE,
} from '../actions/script';

const initialState = {
  scriptData: [],
  scriptTotalPage: 1,
  patientScriptData: [],
  patientScriptTotalPage: 1,
  requestStatus: '',
  scriptNotes: [],
  notesRequestStatus: '',
  scrollingToNoteId: null,
  scriptNoteOrAttachmentDataIds: [],
  notesId: [],
  attachmentsId: [],
  scriptStatuses: [],
  scriptPayments: [],
  scriptAttachment: [],
  scheduleDeliveryMethod: '',
  usPostalResponseData: [],
  postalServicesData: {},
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_SCRIPTS.SUCCESS: {
      return {
        ...state,
        scriptData: payload.data.response,
        scriptTotalPage: payload.data._meta.pageCount,
        requestStatus: 'success',
      };
    }

    case GET_SCRIPTS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case BULK_UPDATE_SCRIPT.SUCCESS: {
      return {
        ...state,
        patientScriptData: state.patientScriptData.map((d) => {
          const foundScripts = payload.data.results.find((r) => r.id === d.id);
          return foundScripts ? { ...d, ...foundScripts, bulkUpdate: false } : d;
        }),
      };
    }

    case GET_PATIENT_SCRIPTS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_PATIENT_SCRIPTS.SUCCESS: {
      return {
        ...state,
        requestStatus: 'success',
        patientScriptData: payload.data.response,
        patientScriptTotalPage: payload.data._meta.pageCount,
      };
    }

    case GET_SCRIPTS_NOTES.REQUEST: {
      return {
        ...state,
        scriptNotes: [],
        notesRequestStatus: 'request',
      };
    }

    case GET_SCRIPTS_NOTES.SUCCESS: {
      return {
        ...state,
        notesRequestStatus: 'success',
        scriptNotes: payload.data.response,
      };
    }

    case DELETE_SCRIPT_NOTE.SUCCESS: {
      return {
        ...state,
        scriptNotes: state.scriptNotes.filter((s) => s.noteId !== payload.noteId),
        notesId: state.notesId.filter((id) => id !== payload.noteId),
      };
    }

    case SCRIPT_NOTE_OR_ATTACHMENT_IDS: {
      return {
        ...state,
        attachmentsId: payload.name === 'attachment' ? payload.ids : [],
        notesId: payload.name === 'note' ? payload.ids : [],
      };
    }

    case CHANGE_SCRIPT_DATA: {
      return {
        ...state,
        patientScriptData: state.patientScriptData.map((p) => (p.id === payload.id
          ? (payload.type === 'updateAllScript'
            ? payload
            : { ...p, [payload.name]: payload.value, bulkUpdate: !!payload.bulkUpdate })
          : p)),
      };
    }

    case DELETE_SCRIPT_DATA: {
      return {
        ...state,
        patientScriptData: state.patientScriptData.filter((p) => (p.id !== payload)),
      };
    }

    case GET_SCRIPT_STATUS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_SCRIPT_STATUS.SUCCESS: {
      return {
        ...state,
        requestStatus: 'success',
        scriptStatuses: payload.data.response.reverse(),
      };
    }

    case GET_SCRIPT_PAYMENTS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_SCRIPT_PAYMENTS.SUCCESS: {
      return {
        ...state,
        requestStatus: 'success',
        scriptPayments: payload.data.response,
      };
    }

    case GET_SCRIPT_ATTACHMENTS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_SCRIPT_ATTACHMENTS.SUCCESS: {
      return {
        ...state,
        requestStatus: 'success',
        scriptAttachment: payload.data.response,
      };
    }

    case SET_SCROLLING_TO_NOTE: {
      return {
        ...state,
        scrollingToNoteId: payload,
      };
    }

    case DELIVERY_METHOD: {
      return {
        ...state,
        scheduleDeliveryMethod: payload,
      };
    }

    case US_POSTAL_RESPONSE.SUCCESS: {
      return {
        ...state,
        usPostalResponseData: payload.data.data,
      };
    }

    case POSTAL_SERVICES_DATA: {
      return {
        ...state,
        postalServicesData: payload,
      };
    }
    default:
      return state;
  }
};

export default reducer;
